import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Image } from '../../components/_all';
import './together.scss';

const TogetherSection = ({ payload }) => {
  const { together } = payload;
  const { t } = useTranslation();

  if (!together) return null;

  return (
    <section className="together">
      <div className="together__container">
        <h2>{t(together.title)}</h2>
        <div className="together__container__cards">
          {together.cards?.map((card, index) => (
            <div className="together__container__card" key={index}>
              <div className="together__container__card--title">
                <img src={card.icon} alt={card.title} />
                <h3>{t(card.title)}</h3>
              </div>
              <p>{t(card.text)}</p>
            </div>
          ))}
        </div>
        {together.cta && (
          <div className="flex__class--rowCenter">
            <a className="button--secondary" href={together.cta.href}>
              {t(together.cta.label)}
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

export default TogetherSection;